import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mp-textarea',
  templateUrl: './mp-textarea.component.html',
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  styleUrl: './mp-textarea.component.scss'
})
export class MpTextareaComponent implements OnInit, OnDestroy {

  @Input() public size: 'small' | 'medium' | 'large' = 'large';
  @Input() public customClasses: string = '';
  @Input() public sizeLocked: boolean = false;
  @Input() public rows: number = 2;
  @Input() public label: string;
  @Input() public disabled: boolean;
  @Input() public textareaValue: unknown;
  @Input() public formControlField: FormControl;

  @Output() textareaValueChange = new EventEmitter<unknown>();

  private valueChangeTimer: ReturnType<typeof setTimeout>;
  private formControlSub: Subscription;

  ngOnInit() {
    if (this.formControlField) {
      this.formControlSub = this.formControlField.valueChanges.subscribe(() => {
        this.onValueChanged();
      });
    }
  }

  ngOnDestroy() {
    if (this.formControlSub) {
      this.formControlSub.unsubscribe();
    }
  }

  public onValueChanged() {
    if (this.valueChangeTimer) {
      clearTimeout(this.valueChangeTimer);
    }

    if (!this.disabled) {
      this.valueChangeTimer = setTimeout(() => {
        if (!this.formControlField) {
          this.textareaValueChange.emit(this.textareaValue);
        } else {
          this.textareaValueChange.emit(this.formControlField.value);
        }
      }, 300);
    }
  }
}
